// src/pages/Signup.js
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Button, TextField, Container, Typography, Box, Alert, CircularProgress, Link } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

function Signup() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { signup } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== passwordConfirm) {
            return setError('As senhas não são iguais.');
        }
        setLoading(true);
        try {
            setError('');
            await signup(email, password);
            navigate('/');
        } catch (err) {
            setError('Falha ao criar a conta. O e-mail pode já estar em uso.');
        }
        setLoading(false);
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            backgroundColor: 'background.default',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
        }}>
            <Container maxWidth="xs">
                <Box sx={{
                    p: 4,
                    borderRadius: '16px',
                    backgroundColor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'divider',
                    boxShadow: '0 24px 64px rgba(0,0,0,0.4)',
                }}>
                    {/* Logo */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
                        <Box sx={{
                            width: 56, height: 56, borderRadius: '14px',
                            background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            mb: 2, boxShadow: '0 8px 24px rgba(99,102,241,0.4)'
                        }}>
                            <AccountBalanceIcon sx={{ fontSize: 28, color: 'white' }} />
                        </Box>
                        <Typography variant="h5" fontWeight={800}>Criar Conta</Typography>
                        <Typography color="text.secondary" variant="body2" sx={{ mt: 0.5 }}>
                            Comece a controlar suas finanças
                        </Typography>
                    </Box>

                    {error && <Alert severity="error" sx={{ mb: 2, borderRadius: '8px' }}>{error}</Alert>}

                    <Box component="form" onSubmit={handleSubmit} noValidate>
                        <TextField
                            margin="normal" required fullWidth
                            label="Seu E-mail" type="email"
                            value={email} onChange={e => setEmail(e.target.value)}
                        />
                        <TextField
                            margin="normal" required fullWidth
                            label="Crie uma Senha" type="password"
                            value={password} onChange={e => setPassword(e.target.value)}
                        />
                        <TextField
                            margin="normal" required fullWidth
                            label="Confirme a Senha" type="password"
                            value={passwordConfirm} onChange={e => setPasswordConfirm(e.target.value)}
                        />

                        <Button
                            type="submit" fullWidth variant="contained"
                            sx={{ mt: 2.5, mb: 1.5, py: 1.2 }} disabled={loading}
                        >
                            {loading ? <CircularProgress size={22} color="inherit" /> : 'Cadastrar'}
                        </Button>

                        <Box sx={{ mt: 2, textAlign: 'center' }}>
                            <Link component={RouterLink} to="/login" variant="body2" color="primary.light">
                                Já tem uma conta? Faça Login
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Signup;